/**
 * 🔆 PoweredByYumix — bande footer argentée signature
 *
 * Yuri spec 2026-02 (cockpit phase): hérite de la pulsation argentée du
 * logo pour ancrer la marque sur toutes les pages auth-protégées.
 *
 * Variants:
 *   • mini    : ligne unique discrète pour le bas de la sidebar
 *   • banner  : bande horizontale avec link /about
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../context/AppContext';

export default function PoweredByYumix({ variant = 'mini', className = '' }) {
  const { language } = useLanguage();
  const fr = (language || 'fr').startsWith('fr');

  if (variant === 'banner') {
    return (
      <div className={`block w-full py-3 text-center ${className}`} data-testid="powered-by-yumix-banner">
        <Link
          to="/about"
          className="group transition-opacity hover:opacity-90"
        >
          <span
            className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] font-bold text-foreground/80"
            style={{ animation: 'yumix-text-pulse 3.6s ease-in-out infinite' }}
          >
            <Sparkles
              className="w-3 h-3"
              style={{ animation: 'yumix-cockpit-pulse 3.6s ease-in-out infinite', color: 'rgba(255,255,255,0.85)' }}
            />
            {fr ? 'Powered by YUMIX' : 'Powered by YUMIX'}
          </span>
        </Link>
        <Link
          to="/security"
          className="block mt-1.5 text-[9px] uppercase tracking-[0.25em] font-semibold text-emerald-400/60 hover:text-emerald-300 transition-colors"
          data-testid="footer-security-link-banner"
        >
          {fr ? '🛡 Sécurité auditée — voir le détail' : '🛡 Security audited — see details'}
        </Link>
      </div>
    );
  }

  // mini variant — sidebar bottom
  return (
    <div className={`px-4 py-2 text-center ${className}`} data-testid="powered-by-yumix-mini">
      <Link
        to="/about"
        className="block transition-opacity hover:opacity-100 opacity-70"
      >
        <span
          className="text-[9px] uppercase tracking-[0.3em] font-bold text-foreground/70"
          style={{ animation: 'yumix-text-pulse 3.6s ease-in-out infinite' }}
        >
          {fr ? 'Powered by YUMIX' : 'Powered by YUMIX'}
        </span>
      </Link>
      <Link
        to="/security"
        className="block mt-1 text-[8.5px] uppercase tracking-[0.25em] font-semibold text-emerald-400/55 hover:text-emerald-300 transition-colors"
        data-testid="footer-security-link"
      >
        {fr ? '🛡 Sécurité auditée' : '🛡 Security audited'}
      </Link>
    </div>
  );
}
